"use client";

import {
  AlertTriangle, ArrowLeft, ArrowDownRight, ArrowUpRight, BadgePercent, Baby,
  Ban, Check, ChevronDown, ChevronRight, CircleAlert, CircleCheck, Clock, Copy,
  ExternalLink, Eye, FileText, Filter, Inbox, LayoutDashboard, LayoutTemplate,
  Loader2, LogOut, MapPin, MessageSquare, MessagesSquare, Minus, Package,
  PackageCheck, PanelLeftClose, PanelLeftOpen, Pencil, Plug, Plus, RefreshCw,
  ReceiptText, RotateCcw, Search, Send, Settings, ShieldCheck, ShoppingBag,
  Sparkles, Star, Store, Tag, Ticket, Trash2, TrendingUp, TriangleAlert, Truck,
  UsersRound, Wand2, X, Zap,
  AtSign, BarChart3, Bell, Bot, Building2, CalendarClock, CalendarDays, ChevronLeft, ChevronUp, CircleUser, Columns3, Download, FileDown, FileUp, History, Info, KanbanSquare, LayoutGrid, ListFilter, Lock, Menu, MessageCircle, MoreHorizontal, Paperclip, PieChart, Play, Printer, Save, SlidersHorizontal, Square, Table2, Undo2, Upload, Users,
  type LucideIcon,
} from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Icons are named by string in `lib/mini-marvel/nav.ts`, so they have to be
 * resolvable at runtime. An explicit registry keeps that possible without
 * pulling the whole icon library into the bundle.
 */
export const MM_ICONS: Record<string, LucideIcon> = {
  AlertTriangle, ArrowLeft, ArrowDownRight, ArrowUpRight, BadgePercent, Baby,
  Ban, Check, ChevronDown, ChevronRight, CircleAlert, CircleCheck, Clock, Copy,
  ExternalLink, Eye, FileText, Filter, Inbox, LayoutDashboard, LayoutTemplate,
  Loader2, LogOut, MapPin, MessageSquare, MessagesSquare, Minus, Package,
  PackageCheck, PanelLeftClose, PanelLeftOpen, Pencil, Plug, Plus, RefreshCw,
  ReceiptText, RotateCcw, Search, Send, Settings, ShieldCheck, ShoppingBag,
  Sparkles, Star, Store, Tag, Ticket, Trash2, TrendingUp, TriangleAlert, Truck,
  UsersRound, Wand2, X, Zap,
  AtSign, BarChart3, Bell, Bot, Building2, CalendarClock, CalendarDays, ChevronLeft, ChevronUp, CircleUser, Columns3, Download, FileDown, FileUp, History, Info, KanbanSquare, LayoutGrid, ListFilter, Lock, Menu, MessageCircle, MoreHorizontal, Paperclip, PieChart, Play, Printer, Save, SlidersHorizontal, Square, Table2, Undo2, Upload, Users,
};

export function MmIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const Glyph = MM_ICONS[name] ?? Package;
  return <Glyph className={cn("size-4", className)} aria-hidden />;
}
